angular.module('qkr').controller('sharedMenusController', ($scope, $uibModal, messageService, FormHelper,
                                                           merchantService, menuService, gettextCatalog,
                                                           sharedMenus, $routeSegment) => {

    new FormHelper($scope); // TODO lethal trainwreck code - fix this

    const vm = $scope;
    
    vm.sharedMenus = sharedMenus;
    vm.menuName = '';

    vm.hasSharedMenus = true;

    vm.openMenu = function($event, menu) {

        const options = {
            menuViewReadonly: merchantService.behaviour(merchantService.merchantInfo, 'editMenuPage.isSharedMenuReadOnly'),
            allowedCustomizeMenuItems: true,
            allowedCreateMenuItems: true
        };

        const modalInstance = $uibModal.open({
            template: require('../templates/menu/view_menu.html'),
            controller: 'menuController',
            windowClass: 'view-menu',
            animation: false,
            resolve: {
                options() {
                    return options;
                },
                menuId() {
                    return menu.id;
                },
                departmentId() {
                    return null;
                }
            }
        });

        modalInstance.result
            .then(() => reloadRoute())
            .catch(() => reloadRoute());
    };

    vm.showCreateSharedMenuButton = function() {
        return (merchantService.behaviour(merchantService.merchantInfo, 'sharedMenusPage.showCreateSharedMenuButton')
            && vm.sharedMenus.length > 0);
    };

    vm.showEditOrDeleteButton = function() {
        return (merchantService.behaviour(merchantService.merchantInfo, 'sharedMenusPage.showEditOrDeleteButton'));
    };

    vm.createMenu = function($event) {

        vm.menuName = '';
        const menuName = '';

        const modalInstance = $uibModal.open({
            template: require('../templates/menu/editMenu.html'),
            controller: 'MenuEditController',
            windowClass: 'modal-huge dragModal',
            backdrop: 'static',
            resolve: {
                menu() {
                    return {
                        name: menuName
                    };
                },
                isNewMenu() {
                    return true;
                },
                isSharedMenu() {
                    return true;
                },
                existingMenuTypes() {
                    return [];
                }

            }
        });

        modalInstance.result.then(newMenu => {
            vm.openMenu($event, newMenu);
        });
    };

    vm.editMenu = function(selectedMenu) {
        menuService.loadMenu(selectedMenu.id).then(promise => {
            menuService.setCurrentMenu(promise);

            const modalInstance = $uibModal.open({
                template: require('../templates/menu/editMenu.html'),
                controller: 'MenuEditController',
                windowClass: 'modal-huge',
                backdrop: 'static',
                resolve: {
                    menu() {
                        return menuService.getCurrentMenu();
                    },
                    isNewMenu() {
                        return false;
                    },
                    isSharedMenu() {
                        return true;
                    },
                    existingMenuTypes() {
                        return [];
                    }

                }
            });

            modalInstance.result.then(() => reloadRoute());

        });
    };

    // Delete the menu
    vm.deleteMenu = function(selectedMenu) {
        menuService.getOutletsUsingProdGroup(selectedMenu).then((outletsUsingProdGroup) => {
            const confirmMeg = gettextCatalog.getString('Are you sure you want to delete the menu') + ' \'' +
                selectedMenu.name + '\' ' + gettextCatalog.getString('from Qkr?');
            const messageArray = [];

            if (outletsUsingProdGroup.length > 0) {
                messageArray.push(gettextCatalog.getString('This menu will be removed from the following outlets:'));

                angular.forEach(outletsUsingProdGroup, (outlet) => {
                    messageArray.push('&bull; ' + outlet.name);
                });
            }

            const modalInstance = $uibModal.open({
                template: require('../templates/common/dynamicModalDialog.html'),
                controller: 'dynamicModalController',
                windowClass: 'fade',
                backdrop: 'static',
                resolve: {
                    title() {
                        return gettextCatalog.getString('Delete Menu');
                    },
                    confirmMsg() {
                        return confirmMeg;
                    },
                    confirmButtonName() {
                        return gettextCatalog.getString('Yes');
                    },
                    cancelButtonName() {
                        return gettextCatalog.getString('No');
                    },
                    multiMsgArray() {
                        return messageArray;
                    }
                }
            });

            modalInstance.result.then(result => {
                if (result === 'ok') {

                    menuService.deleteMenu(selectedMenu)
                        .then(() => reloadRoute())
                        .catch(reason => {
                            messageService.error({
                                message: gettextCatalog.getString('Delete failed:') + ' ' + reason.data.message
                            });
                        });
                }
            });
        });
    };

    function reloadRoute() {
        $routeSegment.chain[0].reload();
    }

});



// WEBPACK FOOTER //
// ./src/controllers/sharedMenus.controller.js